import options from './editor-options';
import { useEnableOrderBrandFilter } from '../../../../feature-flags/hooks/use-enable-order-brand-filter';
import { useEnableFulfillmentProviderFilter } from '../../../../hooks/use-enable-fulfillment-provider-filter';
import { useEnableShopifyShipFromFilter } from '../../../../hooks/use-enable-shopify-ship-from-filter';
import {
  EDITOR_TYPE_SELLER_BRAND,
  EDITOR_TYPE_FULFILLMENT_PROVIDER,
  EDITOR_TYPE_SHOPIFY_SHIP_FROM,
} from '../../constants/filter-editor-type';
import { useMemo } from 'react';

export const useEnabledEditorOptions = () => {
  const hasOrderBrandFilterFlag = useEnableOrderBrandFilter();
  const hasFulfillmentProviderFlag = useEnableFulfillmentProviderFilter();
  const hasShopifyStore = useEnableShopifyShipFromFilter();

  const filteredOptions = useMemo(
    () =>
      options.filter(
        (option) =>
          (option !== EDITOR_TYPE_SELLER_BRAND || hasOrderBrandFilterFlag) &&
          (option !== EDITOR_TYPE_FULFILLMENT_PROVIDER || hasFulfillmentProviderFlag) &&
          (option !== EDITOR_TYPE_SHOPIFY_SHIP_FROM || hasShopifyStore),
      ),
    [hasOrderBrandFilterFlag, hasFulfillmentProviderFlag, hasShopifyStore],
  );

  return filteredOptions;
};
